import { create } from 'zustand';

/**
 * Zustand store for managing emissions navigation state
 * This store handles the flow from shipments with missing emissions data
 * to the emissions table with pre-filled modal data
 */
const useEmissionsNavigationStore = create((set, get) => ({
  // Navigation state
  shouldOpenModal: false,
  navigationData: null,
  isNavigating: false,

  // Actions
  navigateToEmissions: (data) => {
    set({
      shouldOpenModal: true,
      navigationData: {
        supplierId: data.supplierId,
        supplierName: data.supplierName,
        cnGoodId: data.cnGoodId,
        cnGoodCode: data.cnGoodCode,
        cnGoodName: data.cnGoodName,
        installationId: data.installationId || null,
        installationName: data.installationName || null,
        sourceShipmentId: data.sourceShipmentId,
        sourceType: 'shipment_missing_data',
        timestamp: Date.now(),
      },
      isNavigating: true,
    });
  },

  clearNavigationState: () => {
    set({
      shouldOpenModal: false,
      navigationData: null,
      isNavigating: false,
    });
  },

  markModalOpened: () => {
    set({
      shouldOpenModal: false,
      isNavigating: false,
    });
  },

  // Getters
  getNavigationData: () => get().navigationData,
  getShouldOpenModal: () => get().shouldOpenModal,
  getIsNavigating: () => get().isNavigating,
}));

export default useEmissionsNavigationStore;
